/* global AnimateScroll:false */
/* global FormValidator:false */
/* global Intercom:false */
/* global window:false */



// Polyfill for missing NodeList.prototype.forEach in older browsers (like IE11)
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) {
	document.getElementsByTagName('body')[0].classList.add('is-ios');
}

// enable smooth scrolling with some delay to prevent scroll animation when we open
// certain URL with hash
setTimeout(() => {
	document.getElementsByTagName('html')[0].classList.add('is-smooth-scrolling-enabled');
}, 400);

// detect touch devices (global variable)
var isTouchDevice = 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.msMaxTouchPoints;

var isCSSTransitionSupported = function() {
	var b = document.body || document.documentElement,
		s = b.style,
		p = 'transition';

	if (typeof s[p] == 'string') { return true; }

	// Tests for vendor specific prop
	var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];
	p = p.charAt(0).toUpperCase() + p.substr(1);

	for (var i=0; i<v.length; i++) {
		if (typeof s[v[i] + p] == 'string') { return true; }
	}

	return false;
};

var matches = function(ele, selector) {
	return (
		ele.matches ||
		ele.matchesSelector ||
		ele.msMatchesSelector ||
		ele.mozMatchesSelector ||
		ele.webkitMatchesSelector ||
		ele.oMatchesSelector
	).call(ele, selector);
};

// Find the closest element to `ele` and matches the `selector`
var closest = function(ele, selector) {
	var e = ele;
	while (e !== null && e.nodeType === 1) {
		if (matches(e, selector)) {
			return e;
		}
		e = e.parentElement || e.parentNode;
	}
	return null;
};

var getStorageItem = function(name) {
	let storage = window.localStorage.getItem('contentking');

	if (storage) {
		storage = JSON.parse(storage);

		return storage[name];
	}

	return null;
};

var removeStorageItem = function(name) {
	let storage = window.localStorage.getItem('contentking');

	if (storage) {
		storage = JSON.parse(storage);
	} else {
		storage = {};
	}

	delete storage[name];

	window.localStorage.setItem('contentking', JSON.stringify(storage));
};

var setStorageItem = function(name, data) {
	let storage = window.localStorage.getItem('contentking');

	if (storage) {
		storage = JSON.parse(storage);
	} else {
		storage = {};
	}

	storage[name] = data;

	window.localStorage.setItem('contentking', JSON.stringify(storage));
};

var getCookieItem = function(name) {
	return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
};

// API URL const
/* jshint ignore:start */
var API_HOSTNAME = '{{ api_hostname }}';

var OFFCANVAS_NAVIGATION_BREAKPOINT = 625;

var MOBILE_BREAKPOINT = 640;
var DESKTOP_BREAKPOINT = 1024;
var XLARGE_BREAKPOINT = 1424;

// custom method for calling of Intercom to prevent situation when Intercom library is still not loaded
var CallIntercom = function(event, options) {
	try {
		var ss = window.sessionStorage || false;
	} catch(e) {
		var ss = false;
	}

	var intercom = window.Intercom;

	// check for situation when Intercom isn't enabled by cookie preferences
	if (intercom) {
		if (ss && ss.getItem('sessionActive') !== '1')  {
			intercom.activate();
		}

		intercom(event, options);
	} else {
		if (ss) {
			ss.setItem('sessionActive', false);
		}
	}
}

const trigger = function(element, eventName, params = {}) {
	if (window.CustomEvent && typeof window.CustomEvent === 'function') {
		var event = new CustomEvent(eventName, {detail: params});
	} else {
		var event = document.createEvent('CustomEvent');
		event.initCustomEvent(eventName, true, true, params);
	}

	element.dispatchEvent(event);
};

const getGetParameterByName = function(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
//
// Resource: https://stackoverflow.com/a/27078401
const throttle = function(func, wait, options) {
	var context, args, result;
	var timeout = null;
	var previous = 0;
	if (!options) options = {};
	var later = function() {
		previous = options.leading === false ? 0 : Date.now();
		timeout = null;
		result = func.apply(context, args);
		if (!timeout) context = args = null;
	};
	return function() {
		var now = Date.now();
		if (!previous && options.leading === false) previous = now;
		var remaining = wait - (now - previous);
		context = this;
		args = arguments;
		if (remaining <= 0 || remaining > wait) {
			if (timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
			previous = now;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		} else if (!timeout && options.trailing !== false) {
			timeout = setTimeout(later, remaining);
		}
		return result;
	};
};

const resetAccessibleMessage = function(element) {
	element.setAttribute('aria-hidden', 'true');
	element.setAttribute('role', 'none');
	element.setAttribute('aria-live', 'off');
};

const setAccessibleMessage = function(element, role = 'status') {
	element.setAttribute('aria-hidden', 'false');
	element.setAttribute('role', role);
	element.setAttribute('aria-live', 'polite');
};

var globalMethods = {};
/* jshint ignore:end */



(function() {
	/**
	 * Init form validations
	 */

	const formsWithValidator = document.querySelectorAll('form[data-validate]');
	Array.prototype.forEach.call(formsWithValidator, function(form) {
		new FormValidator(form);

		// Shake with invalid forms
		form.addEventListener('forminvalid', function(e) {
			const details = e.detail;

			if (details.formElement) {
				details.formElement.classList.add('shake-animation');

				setTimeout(function() {
					details.formElement.classList.remove('shake-animation');
				}, 1000);
			}
		});
	});



	/**
	 * Animated scrolling effect to specific anchor on the page marked by #hash
	 */

	// Smooth scrolling for browsers that don't support CSS smooth scrolling
	document.addEventListener('click', function(event) {
		if (window.getComputedStyle(document.documentElement).scrollBehavior !== 'smooth') {
			const internalLink = closest(event.target, 'a[href^="#"]');

			if (internalLink) {
				const targetID = internalLink.getAttribute('href');

				if (targetID !== '#') {
					const targetElement = document.querySelector(internalLink.getAttribute('href'));

					if (targetElement) {
						/*
						Replacement of this workaound:

						internalLink.addEventListener('click', (e) => {
							targetElement.scrollIntoView({
								behavior: 'smooth',
							});
							e.preventDefault();
						});

						for browsers where scrollIntoView with options isn't supported (Safari)
						*/

						const targetElementStyle = window.getComputedStyle(targetElement);
						var offset = parseInt(targetElementStyle.marginTop, 10) || 0;

						const stickyHeader = window.innerWidth >= OFFCANVAS_NAVIGATION_BREAKPOINT ?
							document.getElementById('js-sticky-header') : document.getElementById('js-main-header');

						if (stickyHeader) {
							offset += stickyHeader.offsetHeight;
						}

						new AnimateScroll(targetElement, {
							duration: 400,
							easing: 'linear',
							align: 'top',
							padding: offset,
						});

						const hash = decodeURI(internalLink.hash);

						if (window.history.pushState) {
							window.history.pushState(null, null, window.location.pathname + hash);
						} else{
							window.location.hash = hash;
						}

						event.preventDefault();
					}
				}
			}
		}
	});



	/**
	 * Autofocus field inside hero banner
	 */

	const autofocusField = document.querySelector('.js-autofocus-field');
	if (autofocusField && !isTouchDevice) {
		autofocusField.focus();
	}



	/**
	 * Helper allowing to attach GET attributes from URL to link
	 * where this class is placed
	 */

	const elementsWithLink = document.querySelectorAll('.js-append-get-attributes');
	const getAttributes = window.location.search.substr(1);
	if (getAttributes.length > 0) {
		Array.prototype.forEach.call(elementsWithLink, function(element) {
			if (element.hasAttribute('href')) {
				var href = element.getAttribute('href');

				if (href.split('?')[1]) {
					element.setAttribute('href', href + '&' + getAttributes);
				} else {
					element.setAttribute('href', href + '?' + getAttributes);
				}
			}
		});
	}



	/*
	 * Custom intercom activator
	 */

	document.addEventListener('DOMContentLoaded', function() {
		var intercomActivators = document.querySelectorAll('.js-intercom-activator');

		[].forEach.call(intercomActivators, function(intercomActivator) {
			intercomActivator.addEventListener('click', function(e) {
				e.preventDefault();

				if (this.getAttribute('data-predefined-text') && this.getAttribute('data-predefined-text').length > 0) {
					CallIntercom('showNewMessage', this.getAttribute('data-predefined-text'));
				} else {
					CallIntercom('showNewMessage');
				}
			});
		});
	});



	/**
	 * Toggle visibility
	 */

	const visibilityLinks = document.querySelectorAll('.js-toggle-visibility-link');
	Array.prototype.forEach.call(visibilityLinks, function(visibilityLink) {
		visibilityLink.addEventListener('click', function(e) {
			e.preventDefault();

			const toggleVisibilityTarget = document.querySelectorAll(this.getAttribute('data-target'));
			Array.prototype.forEach.call(toggleVisibilityTarget, function(target) {
				const display = target.style.display;
				target.style.display = display === 'none' ? '' : 'none';
			});
		});
	});



	/**
	 * Set page load timestamp to provide info about time spent on page (per session)
	 */

	var sessionTimestamp = window.sessionStorage && window.sessionStorage.getItem('session_timestamp');

	if (!sessionTimestamp || sessionTimestamp === undefined) {
		window.sessionStorage.setItem('session_timestamp', Date.now());
	}



	/**
	 * Add specific class to body when user will do scroll action on the page
	 */

	function handleScroll() {
		var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

		if (scrollTop > 0) {
			document.getElementsByTagName('body')[0].classList.add('is-scrolled');
		} else {
			document.getElementsByTagName('body')[0].classList.remove('is-scrolled');
		}
	}

	window.addEventListener('scroll', throttle(handleScroll, 150, {
		leading: true,
		trailing: true,
	}));

})();
